export const viewPromotion = (
  creativeName: string,
  creativeSlot: string,
  id?: string,
  name?: string
) => {
  dataLayer.push({
    event: 'view_promotion',
    ecommerce: {
      creative_name: creativeName,
      creative_slot: creativeSlot,
      promotion_id: id,
      promotion_name: name,
    },
  });
};

export const selectPromotion = (
  creativeName: string,
  creativeSlot: string,
  id?: string,
  name?: string
) => {
  dataLayer.push({
    event: 'select_promotion',
    ecommerce: {
      creative_name: creativeName,
      creative_slot: creativeSlot,
      promotion_id: id,
      promotion_name: name,
    },
  });
};
